const inputtext = {
  root: {
    background: '{content.background}',
    disabledBackground: '{grayScale.200}',
    disabledColor: '{text.muted.color}',
    filledBackground: '{content.background}',
    filledFocusBackground: '{content.background}',
    borderColor: '#d9d9d9',
    hoverBorderColor: '#c4cbd8',
    focusBorderColor: '{grayScale.700}',
    invalidBorderColor: '{error.border.color}',
    color: '{primitive.black}',
    placeholderColor: '{form.field.placeholderColor}',
    // shadow: 'inset 0 1px 3px 0 rgba(52, 62, 79, 0.1)',
    paddingX: '{form.field.padding.x}',
    paddingY: '{form.field.padding.y}',
    borderRadius: '{border.radius.m}',
    focusRing: {
      width: '0.065rem',
      style: 'solid',
      color: '{grayScale.700}',
      offset: '0',
      shadow: 'none',
    },
    transitionDuration: '{transition.duration}',
    sm: {
      fontSize: '{sizes.s}',
      paddingX: '{sizes.xs}',
      paddingY: '{spacing.xxs}',
    },
    lg: {
      fontSize: '1.25rem',
      paddingX: '{sizes.s}',
      paddingY: '{sizes.xs}',
    },
  },
};

export default inputtext;
